import { LAYOUTS, } from '@voltmoney/types';
import { WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../../routes';
import { ACTION, EDUCATION, } from './types';
import { GoBackAction, needHelpAction, onChangeInput, onSelect, toggleCTA, triggerCTA, } from './actions';
import { getCoBorrowerName, horizontalStepperRepo, } from '../../../../configs/utils';
import { getAppHeader } from '../../../../configs/config';
import { api } from '../../../../configs/api';
import _ from 'lodash';
import SharedPropsService from '../../../../SharedPropsService';
import AsyncStorage from "@react-native-async-storage/async-storage";
const qualificationInputData = [
    { label: 'Up to 12', value: EDUCATION.UP_TO_12 },
    { label: 'Diploma', value: EDUCATION.DIPLOMA },
    { label: 'Graduate', value: EDUCATION.UNDER_GRADUATE },
    { label: 'Post graduate', value: EDUCATION.POST_GRADUATE },
    { label: 'MBA', value: EDUCATION.MBA },
    { label: 'PHD', value: EDUCATION.PHD },
    { label: 'Professional', value: EDUCATION.PROFESSIONAL },
    { label: 'Others', value: EDUCATION.OTHERS },
];
export const template = (stepper, stepResponseObject, fullName, fatherFirstName, fatherLastName, height, showVerticalScroll) => {
    return {
        layout: {
            id: ROUTE.CO_BORROWER_ADDITIONAL_DETAILS,
            type: LAYOUTS.LIST,
            widgets: [
                { id: "coBorrowerKycPage", type: WIDGET.CO_BORROWER_KYC_ADDITIONAL_DETAILS_PAGE }
            ],
        },
        datastore: {
            coBorrowerKycPage: {
                height: height,
                stepperData: stepper,
                userName: fullName,
                applyAction: {
                    type: ACTION.TRIGGER_CTA,
                    payload: {}
                },
                backAction: {
                    type: ACTION.GO_BACK,
                    routeId: ROUTE.CO_BORROWER_ADDITIONAL_DETAILS,
                    payload: {},
                },
                needHelpAction: {
                    type: ACTION.NEED_HELP,
                    routeId: ROUTE.CO_BORROWER_ADDITIONAL_DETAILS,
                    payload: {},
                },
                showVerticalScroll: showVerticalScroll
            },
        },
    };
};
export const kycCoBorrowerAdditionalDetailsMF = {
    onLoad: async ({ showVerticalScroll, getHeight, network }) => {
        const stepper = await horizontalStepperRepo(network);
        const user = await SharedPropsService.getUser();
        let applicationId;
        let coBorrowerId;
        if (await AsyncStorage.getItem("application_id") !== null) {
            applicationId = await AsyncStorage.getItem("application_id");
        }
        else {
            applicationId = user.linkedApplications[0].applicationId;
        }
        const updatedApplicationResponse = await network.get(`${api.borrowerApplication}${applicationId}`, { headers: await getAppHeader() });
        if (await AsyncStorage.getItem("application_id") !== null) {
            coBorrowerId = updatedApplicationResponse.data.currentCoBorrowerAccountId;
        }
        else {
            coBorrowerId = user.linkedApplications[0].currentCoBorrowerAccountId;
        }
        const response = await network.get(`${api.fetchAdditionalDetailsForCoBorrower}${applicationId}/${coBorrowerId}`, { headers: await getAppHeader() });
        user.linkedApplications[0] = response.data.updatedApplicationObj;
        await SharedPropsService.setUser(user);
        const fullName = getCoBorrowerName(user.linkedApplications[0].currentCoBorrowerAccountId, user.linkedApplications[0].coBorrowerAccountMetaData);
        const stepResponseObject = _.get(response, 'data.stepResponseObject', {});
        const fatherFirstName = '';
        const fatherLastName = '';
        return Promise.resolve(template(stepper, stepResponseObject, fullName, fatherFirstName, fatherLastName, getHeight(), showVerticalScroll()));
    },
    actions: {
        [ACTION.TRIGGER_CTA]: triggerCTA,
        [ACTION.STATUS_CHECK]: toggleCTA,
        [ACTION.STATUS_UNCHECK]: toggleCTA,
        [ACTION.INPUT_NAME]: onChangeInput,
        [ACTION.SELECT_QUALIFICATION]: onSelect,
        [ACTION.GO_BACK]: GoBackAction,
        [ACTION.NEED_HELP]: needHelpAction,
    },
};
